import { Status } from "utilities/enumerations/statuses";
import { Map } from "utilities/types/map";
import { TranslatedCopy } from "utilities/interfaces/culture-resources";

// -----------------------------------------------------------------------------------------
// #region Enum
// -----------------------------------------------------------------------------------------

enum InvoiceProductType {
    AnnualFee = 0
}

// #endregion Enum

// -------------------------------------------------------------------------------------------------
// #region Maps
// -------------------------------------------------------------------------------------------------

const InvoiceProductTypeDisplayNames: Map<InvoiceProductType, TranslatedCopy> = {
    [InvoiceProductType.AnnualFee]: "annualFee",
};

const InvoiceProductTypeMap: Map<InvoiceProductType, Status> = {
    [InvoiceProductType.AnnualFee]: Status.Success,
};

// #endregion Maps

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export { InvoiceProductType, InvoiceProductTypeDisplayNames, InvoiceProductTypeMap };

// #endregion Exports
